module.exports = "/images/laser tag (Union selection-working).svg?2f07c8979d707370c7a514a011837b58";